import React, { useEffect, useState } from "react";
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { motion } from "framer-motion";
import obrazek from "../images/banner-images/banner-image-1.jpg";
import { NavLink, useParams } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useSwipeable } from 'react-swipeable';
import { getModelEntryData, useEditry } from '@lazylabs-dev/editry-react';
import { getLocalizedText } from "../utils/textLocalization";
import { getCurrentLanguage } from "../utils/languageSwitcher";
import { FaTimes, FaArrowLeft, FaArrowRight } from "react-icons/fa";

const LOCALE_TO_BUILDER_KEY = {
  'cs-CZ': 'Default',
  'sk-SK': 'sk-SK',
  'pl-PL': 'pl-PL',
  'hu-HU': 'hu-HU'
};

const slugify = (text = '') =>
  text
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const toOptimizedImageUrl = (url) => {
  if (!url || typeof url !== 'string' || !url.startsWith('http') || url.includes('format=webp')) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}format=webp`;
};

const buildGalerie = (news) => {
  /*
  const items = [];

  if (news?.image_url) {
    items.push({ fotka: news.image_url });
  }

  if (Array.isArray(news?.gallery)) {
    news.gallery.forEach((url) => {
      if (url && !items.some((item) => item.fotka === url)) {
        items.push({ fotka: url });
      }
    });
  }

  return items.length > 0 ? items : [{ fotka: obrazek }];
  */

  return [{ fotka: news.image_url }]

};

const parseModelItemData = (item) => {
  const parsed = getModelEntryData(item);
  if (parsed && Object.keys(parsed).length > 0) {
    return parsed;
  }

  if (item && typeof item.data_json === 'string') {
    try {
      return JSON.parse(item.data_json);
    } catch {
      return {};
    }
  }

  return {};
};

const toDisplayString = (value, locale, fallback = '') => {
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }

  if (!value || typeof value !== 'object') {
    return fallback;
  }

  const localeKey = LOCALE_TO_BUILDER_KEY[locale] || 'Default';
  const localeValue = value[localeKey];
  if (typeof localeValue === 'string' || typeof localeValue === 'number') {
    return String(localeValue);
  }

  if (typeof value.Default === 'string' || typeof value.Default === 'number') {
    return String(value.Default);
  }

  const firstString = Object.values(value).find((entry) => typeof entry === 'string' || typeof entry === 'number');
  return firstString != null ? String(firstString) : fallback;
};

const normalizeKolaReferences = (reference) => {
  if (!reference) {
    return [];
  }

  const refs = Array.isArray(reference) ? reference : [reference];

  return refs.filter((ref) => {
    if (!ref || typeof ref !== 'object') {
      return false;
    }

    const model = String(ref.model || '').toLowerCase();
    return model === 'kola' && (ref.id != null || ref.slug);
  });
};

const extractCategoryRefId = (kategorieField) => {
  if (!kategorieField) {
    return null;
  }

  const entries = Array.isArray(kategorieField) ? kategorieField : [kategorieField];

  for (const entry of entries) {
    const ref = entry?.kategora || entry;
    const id = ref?.id ?? ref?.item_id ?? (typeof ref === 'string' || typeof ref === 'number' ? ref : null);
    if (id != null && String(id).trim()) {
      return String(id).trim();
    }
  }

  return null;
};

function App() {
  const { client } = useEditry();
  const currentLocale = getCurrentLanguage();
  const goToBikeText = getLocalizedText('general.go_to_bike');

  const { id } = useParams();
  const [novinka, setNovinka] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [galerie, setGalerie] = useState([]);
  const [normalGalerie, setNormalGalerie] = useState([]);
  const [galleryid, setGalleryid] = useState(0);
  const [refKola, setRefKola] = useState([]);

  useEffect(() => {
    let cancelled = false;

    setIsLoading(true);
    document.title = "Nukeproof | Novinka"

    const resolveBikeReference = async (ref) => {
      const modelsResponse = await client.getPublicModels();
      const models = modelsResponse?.data || [];
      const bikesModel = models.find((model) => String(model.slug || '').toLowerCase() === 'kola');
      const categoriesModel = models.find((model) => String(model.slug || '').toLowerCase() === 'pick-4');

      if (!bikesModel) {
        return null;
      }

      const bikeId = Number(ref.id);
      let modelItem = null;

      if (Number.isInteger(bikeId) && bikeId > 0) {
        try {
          const itemResponse = await client.getPublicModelItemById(bikesModel.id, bikeId);
          modelItem = itemResponse?.data || null;
        } catch {
          modelItem = null;
        }
      }

      if (!modelItem) {
        const itemsResponse = await client.getPublicModelItems(bikesModel.id);
        const allItems = itemsResponse?.data || [];
        modelItem = allItems.find((item) =>
          String(item.id) === String(ref.id) || String(item.slug || '') === String(ref.slug || ref.id)
        ) || null;
      }

      if (!modelItem) {
        return null;
      }

      const bikeData = parseModelItemData(modelItem);
      let kategorieCesta = 'kolo';

      const categoryRefId = extractCategoryRefId(bikeData.kategorie);
      if (categoriesModel && categoryRefId) {
        try {
          const categoriesResponse = await client.getPublicModelItems(categoriesModel.id);
          const categories = categoriesResponse?.data || [];
          const matchedCategory = categories.find((category) => String(category.id) === categoryRefId);

          if (matchedCategory) {
            const categoryData = parseModelItemData(matchedCategory);
            kategorieCesta = String(
              categoryData.cesta || categoryData.nazev || matchedCategory.slug || kategorieCesta
            ).toLowerCase().trim();
          }
        } catch (error) {
          console.error('Nepodařilo se načíst kategorii kola:', error);
        }
      }

      return {
        bikeId: modelItem.id,
        kategorieCesta,
        bikeData: {
          nazev: toDisplayString(bikeData.nazev, currentLocale, modelItem.name || 'Nukeproof'),
          oProduktu: toDisplayString(bikeData.oProduktu || bikeData.oproduktu, currentLocale, ''),
          obrazek: bikeData.obrazek || '',
        },
      };
    };

    const loadReferencedBikes = async (news) => {
      const refs = normalizeKolaReferences(news?.reference);

      if (!refs.length) {
        if (!cancelled) {
          setRefKola([]);
        }
        return;
      }

      const bikes = [];
      for (const ref of refs) {
        try {
          const bikeInfo = await resolveBikeReference(ref);
          if (bikeInfo) {
            bikes.push(bikeInfo);
          }
        } catch (error) {
          console.error('Nepodařilo se načíst referencované kolo:', error);
        }
      }

      if (!cancelled) {
        setRefKola(bikes);
      }
    };

    const loadNewsDetail = async () => {
      try {
        const numericId = Number(id);
        let news = null;

        if (Number.isInteger(numericId)) {
          const response = await client.getPublicNewsById(numericId);
          news = response?.data || null;
        } else {
          const listResponse = await client.getPublishedNews();
          const allNews = listResponse?.data || [];
          const found = allNews.find((item) => slugify(item.title || '') === id);

          if (found) {
            const detailResponse = await client.getPublicNewsById(found.id);
            news = detailResponse?.data || found;
          }
        }

        if (!cancelled && news) {
          setNovinka(news);
          setGalerie(buildGalerie(news));
          setNormalGalerie(news.gallery || [])
          setGalleryid(0);
          document.title = `Nukeproof | ${news.title || 'Novinka'}`;
          await loadReferencedBikes(news);
        } else if (!cancelled) {
          setNovinka(null);
          setRefKola([]);
        }
      } catch (error) {
        console.error("Nepodařilo se načíst novinky:", error);
        if (!cancelled) {
          setRefKola([]);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    loadNewsDetail();

    return () => {
      cancelled = true;
    };
  }, [client, id, currentLocale]);

  const nxtGallery = () => {
    if (galleryid < galerie.length - 1) {
      setGalleryid(galleryid + 1);
      return;
    } else {
      setGalleryid(0);
      return;
    }
  }

  const prvGallery = () => {
    if (galleryid !== 0) {
      setGalleryid(galleryid - 1);
      return;
    } else {
      setGalleryid(galerie.length - 1);
      return;
    }
  }

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => nxtGallery(),
    onSwipedRight: () => prvGallery(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const [showGallery, setShowGallery] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Funkce pro galerii
  const openGallery = (index) => {
    setCurrentImageIndex(index);
    setShowGallery(true);
  };
  
  const closeGallery = () => {
    setShowGallery(false);
  };
  
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === normalGalerie.length - 1 ? 0 : prevIndex + 1
    );
  };
  
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? normalGalerie.length - 1 : prevIndex - 1
    );
  };

  const [touchStartX, setTouchStartX] = useState(0);
  const MIN_SWIPE_DISTANCE = 50;

  const handleTouchStart = (e) => {
    setTouchStartX(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const distance = touchStartX - touchEndX;

    if (distance > MIN_SWIPE_DISTANCE) {
      nextImage();
    }

    if (distance < -MIN_SWIPE_DISTANCE) {
      prevImage();
    }
  };


  return (
    <>
      <motion.div className="page article-example" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
      {isLoading ? (
          <div className="loading-container" />
        ) : novinka ? (
          <>



            <div className="article-gallery">
              <div className="article-gallery-blocker" {...swipeHandlers}>
                <AnimatePresence mode="wait">
                {galerie.map((item, index) => (
                  galleryid === index ? (
                    <motion.img 
                      key={index} 
                      src={toOptimizedImageUrl(item.fotka) || obrazek} 
                      alt={novinka.title || "Článek"} 
                      initial={{opacity: 0}} 
                      animate={{opacity: 1}} 
                      exit={{opacity: 0}} 
                      transition={{duration: 0.1}}
                    />
                  ) : null
                ))}
                </AnimatePresence>
              </div>
              <div className="article-gallery-buttons">
                {galerie.length > 1 && (
                <>
                <button onClick={() => {prvGallery()}} className="gallery-button-left"><MdKeyboardArrowLeft /></button>

                {galerie.map((item, index) => (
                <button key={index} onClick={() => {setGalleryid(index)}} className={galleryid === index ? "gallery-active-button" : ""}></button>
                ))}

                <button onClick={() => {nxtGallery()}} className="gallery-button-right"><MdKeyboardArrowRight /></button>
                </>
                )}
              </div>
            </div>




            <h1>{novinka.title}</h1>
            <p dangerouslySetInnerHTML={{ __html: novinka.content || ''}} className="html-unblock-article news-image-content"/>

            
            <div className="article-under-gallery">
              {normalGalerie.length > 0 && normalGalerie.map((item, index) => (
                <img loading="lazy" key={index} src={toOptimizedImageUrl(item) || obrazek} alt={novinka.title || "Článek"} onClick={() => openGallery(index)}/>
              ))}
            </div>



             {refKola.length > 0 && refKola.map((bikeInfo, index) => (
              <NavLink 
                key={bikeInfo.bikeId || index} 
                to={"/kola/" + bikeInfo.kategorieCesta + "/" + bikeInfo.bikeId}
              >
                <div className="article-bike">
                  <img
                    src={bikeInfo.bikeData.obrazek ? `${bikeInfo.bikeData.obrazek}?format=webp` : obrazek}
                    alt={bikeInfo.bikeData.nazev || "Bike"}
                  />
                  <h3>{bikeInfo.bikeData.nazev}</h3>
                  <h4>{bikeInfo.bikeData.oProduktu}</h4>
                  <button><label>{goToBikeText}</label></button>
                </div>
              </NavLink>
            ))}



              {showGallery && (
                <div className="gallery-modal">
                  <div className="gallery-modal-content">
                    <button className="close-button" onClick={closeGallery}>
                      <FaTimes />
                    </button>
              
                    <div className="gallery-image-container" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
                      <img 
                        src={normalGalerie[currentImageIndex] + "?format=webp"} 
                        alt={`Nukeproof bike gallery ${currentImageIndex + 1}`} 
                      />
                    </div>
              
                    <button className="nav-button prev" onClick={prevImage}>
                      <FaArrowLeft />
                    </button>
              
                    <button className="nav-button next" onClick={nextImage}>
                      <FaArrowRight />
                    </button>
              
                    <div className="gallery-counter">
                      <button className="nav-btn next" onClick={prevImage}><FaArrowLeft /></button>
                      {currentImageIndex + 1} / {normalGalerie.length}
                      <button className="nav-btn prev" onClick={nextImage}><FaArrowRight /></button>
                    </div>
                  </div>
                </div>
              )}


          </>
        ) : (
          <div className="loading-container" />
        )}
      </motion.div>
    </>
  );
}

export default App;
